import { WSButton } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";

export const ButtonRequestInstantPayout: React.FC<{ invoiceId: string }> = ({
  invoiceId
}) => {
  const history = useHistory();

  return (
    <WSButton.Link
      onClick={() => {
        history.push(`/member/invoices/paid/${invoiceId}/instant-deposit`);
      }}
    >
      Receive payout in minutes
    </WSButton.Link>
  );
};
